import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

import { panels } from '../consts';
import { Tab } from './Tab';
import { actions } from '../_redux';

export function Tabs() {
	const { active, totals, sales } = useSelector(
		(state) => state.dashboard,
		shallowEqual
	);
	const dispatch = useDispatch();
	const [scores, setScores] = useState({});

	useEffect(() => {
		if (totals) {
			totals.Sales = sales.total;
			setScores(totals)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [totals]);

	return (
		<Grid container justify='space-between' >
			{panels.map((panel) => (
				<Tab
					title={panel.title}
					icon={panel.icon}
					score={scores[panel.title] || 0}
					key={panel.title}
					active={active === panel.title}
					onClick={() => dispatch(actions.updateActive(panel.title))}
				/>
			))}
		</Grid>
	);
}
